export const CohortPanel = ({ m }) => (
  <div data-testid="admin-cohort-panel">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="label">Live demographic grounding · searched, not recalled</p>
      <span className="font-data text-[10px] text-zinc-600">
        {Object.entries(m?.demographic || {})
          .filter(([, v]) => v !== null && v !== "")
          .map(([k, v]) => `${k}: ${v}`)
          .join("  ·  ") || "cohort not yet established"}
      </span>
    </div>

    <div className="mt-6 space-y-6">
      {(m?.cohort_grounding || []).map((g) => (
        <article key={g.query || g.category} className="border border-[var(--line)] px-5 py-5">
          <div className="flex flex-wrap items-baseline gap-3">
            <span className="font-data text-[10px] uppercase tracking-[0.18em] text-zinc-100">
              {g.verdict}
            </span>
            <span className="label">{g.confidence} confidence</span>
            <span className="label ml-auto">{g.maps_to}</span>
          </div>
          <p className="mt-3 text-sm text-zinc-100">“{g.stated_need}”</p>
          {g.cohort_rate && (
            <p className="mt-2 font-data text-[11px] text-zinc-400">{g.cohort_rate}</p>
          )}
          <p className="mt-3 text-xs leading-relaxed text-zinc-500">{g.basis}</p>
          {g.missing_dimensions?.length > 0 && (
            <p className="mt-2 font-data text-[10px] text-zinc-700">
              uncovered dimensions: {g.missing_dimensions.join(", ")}
            </p>
          )}
          {g.sources?.length > 0 && (
            <ul className="mt-4 space-y-2">
              {g.sources.map((s) => (
                <li key={s.url} className="border-l border-[var(--line-hi)] pl-3">
                  <a
                    href={s.url}
                    target="_blank"
                    rel="noreferrer"
                    className="font-data text-[11px] text-zinc-300 underline decoration-zinc-700 hover:decoration-zinc-300"
                  >
                    {s.title || s.url}
                  </a>
                  {s.published && (
                    <span className="ml-2 font-data text-[10px] text-zinc-700">{s.published}</span>
                  )}
                  {s.figure && <p className="mt-1 text-xs italic text-zinc-600">{s.figure}</p>}
                </li>
              ))}
            </ul>
          )}
        </article>
      ))}

      {(m?.cohort_grounding || []).length === 0 && (
        <p className="font-data text-[11px] text-zinc-600">
          Nothing grounded yet. Needs are checked against live statistics as soon as the subject
          names them in P2 and the cohort frame is known.
        </p>
      )}

      {(m?.needs_seed || []).length > 0 && (
        <div>
          <p className="label mt-8">Stated needs on record</p>
          <ul className="mt-3 space-y-2">
            {m.needs_seed.map((n) => (
              <li key={n.stated_need} className="font-data text-[11px] text-zinc-400">
                “{n.stated_need}” → {n.maps_to} · model read: {n.cohort_comparison}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </div>
);

export default CohortPanel;
